import { type HttpClient } from '@/application/interfaces/http-client';

import getCreditCards from './get-credit-cards';

const creditCardsService = (httpClient: HttpClient.Instance) => ({
  getCreditCards: getCreditCards(httpClient),
});

export default creditCardsService;
